export const getMicrodataAttributes = (type = 'Offer') => ({
  itemScope: true,
  itemType: `http://schema.org/${type}`,
});
